import React, { useState, useContext, useMemo } from "react";
import { getEligibleOrgIds } from "utils/organizationUtils";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";

import * as selectors from "./selectors";
import { LeftMenuContext } from "containers/left-menu/context";

import LeftMenu from "components/left-menu";

const LeftMenuContainer = props => {
	const [context, setContext] = useContext(LeftMenuContext);

	const dispatch = useDispatch();
	const [isOpen, setIsOpen] = useState(true);
	const [currentMenuItem, setCurrentMenuItem] = useState(null);
	let userDetails = useSelector(selectors.selectUserDetails);
	const organizations = useSelector(selectors.selectOrganizations);

	const navigateTo = path => {
		let absolutePath = new RegExp("^(?:[a-z+]+:)?//", "i").test(path) || path.startsWith("mailto:");
		absolutePath ? window.open(path, "_.blank") : dispatch(push(path));
	};

	const orgPrefixChecker = useMemo(() => {
		if (!organizations?.length || !userDetails?.organizationReadPermisions?.length) return null;
		return prefix => getEligibleOrgIds(organizations, prefix);
	}, [organizations, userDetails?.organizationReadPermisions]);

	const isEnabledForOrganization = menuItem => {
		if (!menuItem.organizationPrefix) return true;
		if (!orgPrefixChecker) return false;
		const eligibleOrgIds = orgPrefixChecker(menuItem.organizationPrefix);
		return userDetails?.organizationReadPermisions?.some(id => eligibleOrgIds.has(id)) ?? false;
	};

	const checkAccessPermissions = menuItem => {
		if (menuItem.permissionsShouldMatchOrganization) {
			if (!orgPrefixChecker || !menuItem.organizationPrefix) return false;
			const eligibleOrgIds = orgPrefixChecker(menuItem.organizationPrefix);
			const orgEnabled = userDetails?.organizationReadPermisions?.some(id => eligibleOrgIds.has(id)) ?? false;
			if (!orgEnabled) return false;
			return userDetails?.readPermissions?.some(rp => eligibleOrgIds.has(rp.organization) && menuItem.accessPermissions?.some(ap => rp.actionPermissions?.includes(ap))) ?? false;
		}
		const hasPermission = !menuItem.hasOwnProperty("accessPermissions") || userDetails?.permissions?.some(up => menuItem.accessPermissions?.includes(up));
		return hasPermission && isEnabledForOrganization(menuItem);
	};

	return (
		<LeftMenu
			userDetails={userDetails}
			open={isOpen}
			menuItems={context
				?.filter(mi => checkAccessPermissions(mi) && !mi.hasOwnProperty("isFooter"))
				?.map(mi => ({
					...mi,
					children: mi.children?.filter(cmi => checkAccessPermissions(cmi))?.map(cmi => 
							({
        						...cmi,
        						children: cmi.children?.filter(ccmi => checkAccessPermissions(ccmi)),
      						})),
				}))}
			ToggleSidebar={() => setIsOpen(!isOpen)}
			navigateTo={path => navigateTo(path)}
			currentMenuItem={currentMenuItem}
			setCurrentMenuItem={setCurrentMenuItem}
			footerMenuItems={context
				?.filter(mi => checkAccessPermissions(mi) && mi.hasOwnProperty("isFooter"))
				?.map(mi => ({
					...mi,
					children: mi.children?.filter(cmi => checkAccessPermissions(cmi)),
				}))}
			{...props}
		/>
	);
};

export default LeftMenuContainer;
